import { useContext } from 'react';
import { useApproval, useApprovalCount } from '../../../../Hooks/TT_ELD/NewAccounts';
import ApprovalTable from './CustomTable/ApprovalTable';
import { Button } from 'antd';
import SearchInput from '../../../../Utils/SearchInput';
import RefreshContext from '../../../utils/context';

type EmailNotVerifiedProps = {
  companyName: string;
  setCompanyName: (value: string) => void;
  username: string;
  setUsername: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  skip: string;
  setSkip: (value: string) => void;
};

const EmailNotVerified = ({
  companyName,
  setCompanyName,
  username,
  setUsername,
  email,
  setEmail,
  skip,
  setSkip,
}: EmailNotVerifiedProps) => {
  const { data, refetch, isLoading, isFetching } = useApproval(
    username,
    email,
    companyName,
    skip,
    false,
  );

  const count = useApprovalCount();

  const onChange = (query: any) => {
    setSkip(query.current);
  };

  const handleChange = (event: string, inputName: string) => {
    const updateFunctions: Record<string, (value: string) => void> = {
      companyName: setCompanyName,
      email: setEmail,
      username: setUsername,
    };

    if (updateFunctions[inputName]) {
      updateFunctions[inputName](event.trim());
      setSkip('1');
    }
  };

  const { refetchBtn, setRefetchBtn } = useContext(RefreshContext);
  const RefToggler = () => {
    setRefetchBtn(refetchBtn + 1);
  };
  const updates = () => {
    refetch();
    count.refetch();
    RefToggler();
  };

  return (
    <div className="mainPage">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 10,
        }}
      >
        <SearchInput
          value={companyName}
          onDebounceChange={(value: string) => handleChange(value, 'companyName')}
          placeholder={'Search by company'}
        />
        <SearchInput
          value={username}
          onDebounceChange={(value: string) => handleChange(value, 'username')}
          placeholder={'Search by username'}
        />
        <SearchInput
          value={email}
          onDebounceChange={(value: string) => handleChange(value, 'email')}
          placeholder={'Search by email'}
        />
        <Button style={{ marginLeft: 'auto' }} size={'large'} onClick={updates}>
          Refresh
        </Button>
      </div>

      <ApprovalTable
        data={data?.data}
        onChange={onChange}
        skip={skip}
        total={data?.count}
        isLoading={isLoading}
        isFetching={isFetching}
        refetch={updates}
        currentTab="notVerified"
      />
    </div>
  );
};

export default EmailNotVerified;
